module.exports = __webpack_public_path__ + "img/img_left_nav_notify_hover.e15fbc79.svg";